import React from 'react';
import { useUser } from '../components/UserContext';
import { Heading } from '../components/heading';
import { Text } from '../components/text';
import { ClientComisiones } from '../components/ClientComisiones';
import { MetasPrimaCard } from '../components/MetasPrimaCard';

/**
 * Comisiones — the org-wide comisión ledger, owners only.
 *
 * The heavy lifting lives in ClientComisiones (shared with nothing else now,
 * but written to take an optional clientId); without one it renders every
 * movement in orgs/{org}/comisiones with a Cliente column.
 */
export default function Comisiones() {
  const { isOwner, loading } = useUser();

  if (loading) {
    return <div className="py-8 text-center text-azul-surelia/70">Cargando…</div>;
  }

  if (!isOwner) {
    return (
      <div className="p-6">
        <Heading level={2} className="text-xl font-bold text-azul-surelia">Comisiones</Heading>
        <Text className="text-sm text-azul-surelia/70 mt-2">
          Esta sección solo está disponible para el owner de la organización.
        </Text>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4">
      <ClientComisiones />
      <MetasPrimaCard />
    </div>
  );
}
